<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />">
</ngx-spinner>
<app-bread-crumb></app-bread-crumb>

<div class="tab-content-top-box">
  <h1 class="main-title">
    {{
    langObj
    ? langObj?.PreventiveMaintenanceTaskForm
    : ("PreventiveMaintenanceTaskForm" | translate)
    }}
  </h1>
</div>

<form [formGroup]="preTaskForm">
  <div class="w-100 prevForm">
    <mat-form-field class="w-22">
      <mat-label>{{
        langObj ? langObj?.MachineName : ("MachineName" | translate)
        }}</mat-label>
      <input type="text" matInput formControlName="MachineName" [(ngModel)]="preTask.MachineName" />
    </mat-form-field>

    <mat-form-field class="w-22">
      <mat-label>{{
        langObj ? langObj?.TaskDescription : ("TaskDescription" | translate)
        }}</mat-label>
      <input type="text" matInput formControlName="TaskDesc" [(ngModel)]="preTask.TaskDesc" />
    </mat-form-field>

    <mat-form-field class="w-22">
      <mat-label>{{
        langObj ? langObj?.Frequency : ("Frequency" | translate)
        }}</mat-label>
      <input type="text" matInput formControlName="FrequencyName" [(ngModel)]="preTask.FrequencyName" />
    </mat-form-field>

    <mat-form-field class="w-22">
      <mat-label>{{
        langObj ? langObj?.Duration : ("Duration" | translate)
        }}</mat-label>
      <input type="number" matInput formControlName="Duration" [(ngModel)]="preTask.Duration" />
    </mat-form-field>

    <mat-form-field class="w-22">
      <mat-label>{{
        langObj ? langObj?.ActivityType : ("ActivityType" | translate)
        }}</mat-label>
      <input type="text" matInput formControlName="TaskName" [(ngModel)]="preTask.TaskName" />
    </mat-form-field>

    <mat-form-field class="w-22">
      <mat-label>{{
        langObj ? langObj?.Status : ("Status" | translate)
        }}</mat-label>
      <mat-select [(ngModel)]="preTask.Status" formControlName="status" [ngClass]="{
          'text-green': preTask.Status == 1,
          'text-red': preTask.Status == 0
        }">
        <mat-option *ngFor="let Status of StatusList" [value]="Status.ID">
          {{ Status.Value }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="w-22">
      <mat-label>{{
        langObj ? langObj?.StartTime : ("StartTime" | translate)
        }}</mat-label>
      <input matInput readonly [ngxMatDatetimePicker]="picker1" formControlName="startTime" [min]="minDate"
        [max]="maxDate" [disabled]="disableStartTime || isviewMode" [(ngModel)]="preTask.StartTime" />
      <mat-datepicker-toggle matSuffix [for]="$any(picker1)"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker #picker1 [enableMeridian]="true"></ngx-mat-datetime-picker>
      <mat-error>{{
        langObj
        ? langObj?.StartTimeIsRequired
        : ("StartTimeIsRequired" | translate)
        }}</mat-error>
    </mat-form-field>

    <mat-form-field class="w-22">
      <mat-label>{{
        langObj ? langObj?.FinishTime : ("FinishTime" | translate)
        }}</mat-label>
      <input matInput readonly [disabled]="isviewMode" [ngxMatDatetimePicker]="picker2" formControlName="finishTime"
        [(ngModel)]="preTask.FinishTime" (dateChange)="dateChanged('finishTime')" />
      <mat-datepicker-toggle matSuffix [disabled]="isviewMode" [for]="$any(picker2)"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker #picker2 [disabled]="isviewMode" [enableMeridian]="true"></ngx-mat-datetime-picker>
    </mat-form-field>

    <button mat-flat-button color="accent" type="button" class="upload" (click)="openFile()" *ngIf="!isviewMode">
      {{ langObj ? langObj?.UploadFile : ("UploadFile" | translate) }}
    </button>
    <input type="file" (change)="readFile($event)" class="d-none" #fileInput accept="image/*" multiple />

    <mat-slide-toggle #toggleElement [checked]="toggleChecked" (change)="onToggleChange($event)"
      [disabled]="isviewMode">{{
      langObj ? langObj?.SparePartsChanged : ("SparePartsChanged" | translate)
      }}
    </mat-slide-toggle>

    <mat-form-field appearence="fill" class="remarks">
      <mat-label>{{
        langObj ? langObj?.Remarks : ("Remarks" | translate)
        }}*</mat-label>
      <textarea matInput type="text" formControlName="remarks" (input)="onRemarksChange($event)"
        [(ngModel)]="preTask.Remarks" [readonly]="isviewMode">
      </textarea>
      <mat-error>{{
        langObj ? langObj?.RemarksisRequired : ("RemarksisRequired" | translate)
        }}</mat-error>
    </mat-form-field>
  </div>

  <h2 *ngIf="
      (FileData && FileData.length) || (EditFileData && EditFileData.length)
    ">
    {{ langObj ? langObj?.TechnicianImages : ("TechnicianImages" | translate) }}
  </h2>
  <div *ngIf="FileData && FileData.length" class="imgflex">
    <div *ngFor="let file of FileData; let i = index" class="relative">
      <div>
        <img *ngIf="file.FileType == 'image'" [src]="file.ImageSrc" alt="" width="250px" height="200px" />
      </div>

      <img src="./assets/images/remove.png" (click)="removeFile(i)" class="absolute" alt="" width="20px"
        height="20px" />
    </div>
  </div>

  <div *ngIf="EditFileData && EditFileData.length" class="imgflex">
    <div *ngFor="let file of EditFileData; let i = index" class="relative">
      <div>
        <img [src]="blobStorageUrl + file.ImageSrc" alt="" width="250px" height="200px" (click)="imgview($event)" />
      </div>

      <img src="./assets/images/delete.png" (click)="deleteFile(i)" class="absolute" alt="" width="20px" height="20px"
        *ngIf="!isviewMode" />
    </div>
  </div>

  <hr style="opacity: 0.3; margin-top: 20px" />
  <div class="w-100 prevForm">
    <mat-tab-group (selectedTabChange)="onTabChange($event)">
      <mat-tab>
        <ng-template mat-tab-label>
          {{ langObj ? langObj?.SOP : ("SOP" | translate) }}
        </ng-template>
        <div *ngIf="TaskFiles && TaskFiles.length" class="imgflex">
          <div *ngFor="let file of TaskFiles; let i = index" class="relative">
            <div>
              <img *ngIf="file.FileType == 'image'" [src]="blobStorageUrl + file.ImageSrc" alt="" width="250px"
                height="200px" />

              <video *ngIf="file.FileType == 'video'" width="250" height="200" controls>
                <source [src]="blobStorageUrl + file.ImageSrc" type="video/mp4" />
                {{
                langObj
                ? langObj?.Yourbrowserdoesnotsupportthevideotag
                : ("Yourbrowserdoesnotsupportthevideotag" | translate)
                }}
              </video>

              <!-- <a *ngIf="file.FileType == 'application'" [href]="blobStorageUrl + file.ImageSrc" target="_blank"
                download>
                <img src="./assets/images/show-pdf2.png" width="200" height="200" alt="pdf" />
              </a> -->


              <a *ngIf="file.FileExtension === 'pdf'" [href]="blobStorageUrl+file.ImageSrc" download>
                <img src="./assets/images/show-pdf2.png" width="200" height="200" alt="pdf">
              </a>

              <a *ngIf="file.FileExtension === 'doc' || file.FileExtension === 'docx'"
                [href]="blobStorageUrl+file.ImageSrc" download>
                <img src="./assets/images/word-icon.png" width="200" height="200" alt="word">
              </a>

              <a *ngIf="file.FileExtension === 'xls' || file.FileExtension === 'xlsx'"
                [href]="blobStorageUrl+file.ImageSrc" download>
                <img src="./assets/images/excel-icon.png" width="200" height="200" alt="excel">
              </a>

              <a *ngIf="file.FileExtension === 'txt'" [href]="blobStorageUrl+file.ImageSrc" download>
                <img src="./assets/images/notepad-icon.jpg" width="200" height="200" alt="notepad">
              </a>

              <a *ngIf="file.FileType !== 'image' &&
          file.FileType !== 'video' &&
          file.FileExtension !== 'pdf' &&
          file.FileExtension !== 'doc' &&
          file.FileExtension !== 'docx' &&
          file.FileExtension !== 'xls' &&
          file.FileExtension !== 'xlsx' &&
          file.FileExtension !== 'txt'" [href]="blobStorageUrl+file.ImageSrc" download>
                <img src="./assets/images/other-file-icon.png" width="200" height="200" alt="pdf">
              </a>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          {{ langObj ? langObj?.MeterReading : ("MeterReading" | translate) }}
        </ng-template>
        <div class="wrapper-box wrapper-box-shadow table-wrapper p-p-1">
          <table mat-table class="basic-table plant-model-table" matSort [dataSource]="meterReadingData">
            <!-- Parameter Column -->
            <ng-container matColumnDef="parameter">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">
                  {{ langObj ? langObj?.Parameter : ("Parameter" | translate) }}
                </p>
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.ParameterName }}
              </td>
            </ng-container>

            <!-- Target Column -->
            <ng-container matColumnDef="target">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">
                  {{ langObj ? langObj?.Target : ("Target" | translate) }}
                </p>
              </th>
              <td mat-cell *matCellDef="let element">{{ element.Target }}</td>
            </ng-container>

            <!-- Actual Column -->

            <ng-container matColumnDef="tiggerAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">
                  {{ langObj ? langObj?.TriggerAt : ("TriggerAt" | translate) }}
                </p>
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.TrigerAtValue }}
              </td>
            </ng-container>

            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">
                  {{
                  langObj
                  ? langObj?.ResultOnDate
                  : ("ResultOnDate" | translate)
                  }}
                </p>
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.ResultOnDate | date : "dd-MM-yyyy hh:mm a" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="actual">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">
                  {{ langObj ? langObj?.Actual : ("Actual" | translate) }}
                </p>
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field appearance="fill" class="field-fill-table" style="width: 40%">
                  <input matInput type="number" [readonly]="isviewMode" (change)="actualChange($event, element)"
                    placeholder="{{
                      langObj ? langObj?.AddValue : ('AddValue' | translate)
                    }}" value="{{ element.Actual }}" min="0" />
                </mat-form-field>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="externalWorkColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: externalWorkColumns"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">
                {{
                langObj ? langObj?.nodatamatch : ("nodatamatch" | translate)
                }}
              </td>
            </tr>
          </table>
          <mat-paginator class="basic-paginataor" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
          </mat-paginator>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          {{
          langObj
          ? langObj?.SparePartsUsedDetails
          : ("SparePartsUsedDetails" | translate)
          }}
        </ng-template>
        <mat-form-field appearence="fill" class="remarks" style="margin-top: 10px">
          <mat-label>{{
            langObj
            ? langObj?.SparePartsUsedDetails
            : ("SparePartsUsedDetails" | translate)
            }}</mat-label>
          <textarea matInput rows="10" type="text" formControlName="sparepartsused" [(ngModel)]="preTask.SparePartsUsed"
            [readonly]="isviewMode">
          </textarea>
        </mat-form-field>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          {{
          langObj ? langObj?.WorkLogDetails : ("WorkLogDetails" | translate)
          }}
        </ng-template>

        <div [formGroup]="workLogForm" class="work-log-details">
          <mat-card>
            <mat-card-header>
              <mat-card-title>Work Log</mat-card-title>
            </mat-card-header>

            <mat-card-content>
              <!-- Current Input Form -->
              <div class="form-row" [formGroup]="workLog" *ngIf="!isviewMode">
                <mat-form-field appearance="fill" class="form-input">
                  <mat-label>Title</mat-label>
                  <!-- <input matInput formControlName="title" placeholder="Enter work log title"
                    (keydown)="onKeydown($event)"
                    [class.is-invalid]="workLog.get('title')?.invalid && workLog.get('title')?.touched" /> -->
                  <input matInput formControlName="title" maxlength="200" placeholder="Enter work log title"
                    (keydown)="onKeydown($event)"
                    [class.is-invalid]="workLog.get('title')?.invalid && workLog.get('title')?.touched" />
                  <mat-hint align="end">
                    {{ workLog.get('title')?.value?.length || 0 }}/200
                  </mat-hint>
                  <mat-error *ngIf="workLog.get('title')?.invalid && workLog.get('title')?.touched">
                    <span *ngIf="workLog.get('title')?.errors?.['required']">Title is required</span>
                  </mat-error>
                </mat-form-field>

                <!-- Add/Edit Button -->
                <button mat-mini-fab [color]="editingIndex !== null ? 'accent' : 'primary'" (click)="addWorkLog()"
                  [disabled]="workLog.invalid || !workLog.get('title')?.value?.trim()"
                  [matTooltip]="editingIndex !== null ? 'Update work log' : 'Add new work log'"
                  aria-label="Add or edit work log" style="margin-left: 10px; margin-bottom: 20px">
                  <mat-icon>{{ editingIndex !== null ? 'edit' : 'add' }}</mat-icon>
                </button>

                <!-- Reset Button (always shown) -->
                <button mat-mini-fab color="accent" (click)="resetWorkLogForm()" matTooltip="Reset" aria-label="Reset"
                  style="margin-left: 5px; margin-bottom: 20px">
                  <mat-icon>refresh</mat-icon>
                </button>

              </div>

              <!-- Saved Logs List -->
              <mat-list *ngIf="savedWorkLogs.length > 0; else noWorkLogs">
                <mat-list-item *ngFor="let log of savedWorkLogs; let i = index" class="work-log-item">
                  <div class="left-actions">
                    <span class="id-text">{{ i + 1 }} - {{ log.title }}</span>
                  </div>
                  <div class="list-item-content" *ngIf="!isviewMode">
                    <button mat-icon-button (click)="editWorkLog(i)" matTooltip="Edit work log" aria-label="Edit">
                      <mat-icon style="color: #1d1dd4">edit</mat-icon>
                    </button>

                    <button mat-icon-button color="warn" (click)="removeWorkLog(i)" matTooltip="Delete work log"
                      aria-label="Delete">
                      <mat-icon style="color: red">delete</mat-icon>
                    </button>
                  </div>
                </mat-list-item>
              </mat-list>

              <ng-template #noWorkLogs>
                <p>No work logs available.</p>
              </ng-template>

              <!-- <div class="mt-3">
                <h4>Saved Logs:</h4>
                <pre>{{ savedWorkLogs | json }}</pre>
                <h4>Current Input:</h4>
                <pre>{{ workLogForm.value | json }}</pre>
              </div> -->
            </mat-card-content>
          </mat-card>
        </div>




      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          {{ langObj ? langObj?.Checklist : ("Checklist" | translate) }}
          <span [ngStyle]="{
              color: getCompletionColor(checklistScore),
              'margin-left': '8px'
            }">
            ({{ checklistScore }}%)
          </span>
        </ng-template>

        <!-- <app-prev-task-checklist-execution [taskId]="taskId" [isviewMode]="isviewMode"
                    [technicianTaskId]="preTask.ID"
                    (checklistUpdated)="getChecklistData()"></app-prev-task-checklist-execution> -->
        <app-prev-task-checklist-execution [taskId]="preTask.ID" [isviewMode]="isviewMode"
          (checklistUpdated)="getChecklistData()"></app-prev-task-checklist-execution>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <!-- External Work -->
          {{ langObj ? langObj?.ExternalWork : ("ExternalWork" | translate) }}
        </ng-template>
        <button *ngIf="(isWrite | permissionChecker) && !isviewMode" style="margin-top: 10px" mat-flat-button
          color="accent" (click)="openWOdialog()" [disabled]="taskStatus === 'Done'">
          {{ langObj ? langObj?.AddWorkOrder : ("AddWorkOrder" | translate) }}
        </button>
        <ag-grid-angular style="width: 100%; height: 24vw; margin-top: 10px" class="ag-theme-alpine" [rowData]="rowData"
          [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" (cellClicked)="cellClicked($event)"
          [gridOptions]="gridOptions" [frameworkComponents]="frameworkComponents" [pagination]="true"
          [paginationPageSize]="10">
        </ag-grid-angular>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="center w-100">
    <button class="cancel" routerLink="/PM/TechnicianExecutionWindow" type="button">
      Cancel
    </button>
    <button mat-raised-button class="partially-save"
      *ngIf="!isviewMode && (isUpdate | permissionChecker) && !showSubmit" type="button" (click)="onPartiallySave()">
      Partially Save
    </button>

    <button mat-raised-button (click)="onSubmit()" class="submit"
      *ngIf="!isviewMode && (isUpdate | permissionChecker) && showSubmit">
      <span class="spinner-border-sm">{{
        langObj ? langObj?.Submit : ("Submit" | translate)
        }}</span>
    </button>
  </div>
</form>
<!-- img popup -->
<ng-template #technicianimageModal>
  <button mat-mini-fab color="warn" [mat-dialog-close]="{ closed: true }">
    <mat-icon>close</mat-icon>
  </button>
  <mat-carousel timings="250ms ease-in" [autoplay]="false" interval="5000" color="accent" [loop]="true"
    [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true" [useMouseWheel]="true" orientation="ltr">
    <mat-carousel-slide #matCarouselSlide *ngFor="let file of EditFileData; let i = index"
      [image]="blobStorageUrl + file.ImageSrc" overlayColor="#00000040" [hideOverlay]="false">
    </mat-carousel-slide>
  </mat-carousel>
</ng-template>
<!-- img popup -->

<ng-template #subTaskDialog>
  <div mat-dialog-title class="mat-title">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="main-title" *ngIf="subtaskFormMode">Add Sub Task</h1>
      <h1 class="main-title" *ngIf="!subtaskFormMode">Update Sub Task</h1>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>

  <!-- Form -->
  <form [formGroup]="subTaskForm" (ngSubmit)="subtaskFormMode ? submitForm() : updateSubtaskForm()">
    <div class="w-100 prevForm">
      <input type="hidden" formControlName="Id" />
      <!-- WO Details -->
      <mat-form-field appearence="fill" class="remarks" style="margin-top: 10px">
        <mat-label>WO Details<span> *</span></mat-label>
        <textarea matInput rows="3" type="text" formControlName="woDetails" placeholder="Enter Work Order details">
        </textarea>
      </mat-form-field>

      <!-- Responsible (Dropdown of Technician Names) -->
      <mat-form-field class="w-22">
        <mat-label>Responsible<span> *</span></mat-label>
        <mat-select formControlName="responsible" (openedChange)="onPanelClose($event, 'tech', machineSearchInput)">
          <input #machineSearchInput (keyup)="searchValues($event, 'tech')" class="form-control w-100"
            placeholder="Search Technicians" />
          <mat-option *ngFor="let tech of filteredTechnicianList" [value]="tech.id">
            {{ tech.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div>

        <!-- Toggle to Choose Vendor Input Type -->
        <mat-slide-toggle #vendorElement class="w-22" [checked]="vendorToggle" style="margin-left: 30rem"
          [disabled]="subTaskForm.disabled" (change)="onVendorToggleChange($event)">{{ langObj ? langObj?.AddNewVendor : ("AddNewVendor" | translate) }}
        </mat-slide-toggle>

        <!-- External Vendor Dropdown -->
        <mat-form-field *ngIf="vendorMode === 'existing'" style="margin-left: 30rem" class="w-22">
          <mat-label>Select External Vendor</mat-label>
          <mat-select formControlName="externalVendor"
            (openedChange)="onPanelClose($event, 'vender', venderSearchInput)">
            <input #venderSearchInput (keyup)="searchValues($event, 'vender')" class="form-control w-100"
              placeholder="Search Vendor" />
            <mat-option *ngFor="let vendor of vendorsList" [value]="vendor.Id">
              {{ vendor.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- New Vendor Input -->
        <mat-form-field *ngIf="vendorMode === 'new'" style="margin-left: 30rem" class="w-22">
          <mat-label>Enter New Vendor</mat-label>
          <input matInput placeholder="Enter vendor name" formControlName="newVendorName" />
        </mat-form-field>
      </div>

      <!-- Target Date -->
      <mat-form-field class="w-22">
        <mat-label>Target Date<span> *</span></mat-label>
        <input matInput [matDatepicker]="picker" formControlName="targetDate" [matDatepickerFilter]="disablePastDates"
          placeholder="Choose a date" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Buttons -->
    <div class="form-buttons mt-3">
      <button mat-flat-button color="accent" style="margin-top: .5rem;" *ngIf="subtaskFormMode && !isviewMode"
        [disabled]="!subTaskForm.valid" type="submit">
        Submit
      </button>
      <button mat-flat-button color="accent" *ngIf="!subtaskFormMode && !isviewMode" [disabled]="!subTaskForm.valid"
        type="submit">
        Update
      </button>
    </div>
  </form>
</ng-template>